import { useEffect } from 'react';

import { MessageKey, useT } from '../i18n';

import { scheduleStreakReminders } from './nativeAlarm';
import { MILESTONES, planReminders, StreakStats } from './streak';

const VARIANTS = { keep: 4, comeback: 3, congrats: 3 } as const;

/**
 * Keeps the phone's scheduled streak notifications in step with the streak: rebuilt whenever a session is
 * finished or the option / language changes, and cleared when the option is off. A no-op in a browser.
 */
export const useStreakReminders = (
    stats: StreakStats,
    enabled: boolean
): void => {
    const t = useT();
    const { lastDay, streak, lastRecovery } = stats;
    useEffect(() => {
        if (!enabled) {
            void scheduleStreakReminders([]);
            return;
        }
        const notices = planReminders(
            { lastDay, streak, lastRecovery },
            new Date()
        ).map((r) => {
            const key =
                r.kind === 'congrats' && MILESTONES.includes(r.streak)
                    ? 'streak.notify.milestone'
                    : `streak.notify.${r.kind}.${r.variant % VARIANTS[r.kind]}`;
            return {
                at: r.at,
                title: t('streak.notify.title'),
                body: t(key as MessageKey, { count: r.streak }),
            };
        });
        void scheduleStreakReminders(notices);
    }, [lastDay, streak, lastRecovery, enabled, t]);
};
